<template>
  <div class="sidebar">
    <el-menu
      :default-active="activeMenu"
      :collapse="false"
      :background-color="variables.menuBg"
      :text-color="variables.menuText"
      :active-text-color="variables.menuActiveText"
      :unique-opened="false"
      :collapse-transition="true"
      mode="vertical"
      class="el-menu-vertical-container"
    >
      <item
        v-for="item in menus"
        :key="item.path"
        :item="item"
        :base-path="item.path"
      />
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Item from './Item.vue';
import variables from '@/assets/css/variables.styl';

export default {
  name: 'SideMenu',
  data() {
    return {
      menus: [],
    };
  },
  components: {
    Item,
  },
  computed: {
    ...mapGetters({
      routes: 'permissionRoutes',
    }),
    activeMenu() {
      const routes = this.$route.matched.concat();
      const { hidden } = this.$route.meta;

      if (routes.length >= 3 && hidden) {
        routes.pop();
        return routes[routes.length - 1].path;
      }
      return routes.pop().path;
    },
    variables() {
      return variables;
    },
  },
  created() {
    if (this.routes) {
      this.menus = this.routes.find((item) => item.path === '/').children;
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~assets/css/mixins'
@import '~assets/css/variables'
.sidebar
  flex-column()
  flex-shrink 0
  height calc(100% - 64px)
  padding 16px 0
  background-color $menuBg
  color $menuText
  overflow hidden
  z-index 99
  .el-menu
    border-right 0
  .el-menu-vertical-container:not(.el-menu--collapse)
    width 240px
</style>
